import React, { useEffect, useState } from "react";
import { ArrowUpCircle } from "lucide-react";
import { useApp } from "../context/AppContext";
import { subscribeAppVersion, openStoreUrl } from "../lib/appVersion";
import { API } from "../api";

/**
 * Mandatory update: full-screen, no close button. Shown on native builds whose
 * version is below the minimum set by the Master. Disappears by itself once the
 * updated app reports a version >= minimum.
 */
export const ForceUpdateGate = () => {
  const { t } = useApp();
  const [status, setStatus] = useState(null);
  useEffect(() => subscribeAppVersion(setStatus), []);
  if (!status?.force) return null;
  const img = status.force_image_url ? `${API.replace(/\/api$/, "")}${status.force_image_url}` : null;
  return (
    <div
      data-testid="force-update-gate"
      className="fixed inset-0 z-[1000] bg-[#0b1220] text-white flex flex-col items-center justify-center px-6"
      style={{ paddingTop: "env(safe-area-inset-top, 0px)", paddingBottom: "max(env(safe-area-inset-bottom, 0px), 16px)" }}
    >
      <button
        type="button"
        data-testid="force-update-image"
        onClick={() => openStoreUrl(status.platform, status.force_store_url)}
        className="w-full max-w-sm aspect-square rounded-3xl overflow-hidden bg-white/5 flex items-center justify-center active:scale-[0.99] transition-transform"
      >
        {img ? (
          <img src={img} alt="" className="w-full h-full object-cover" />
        ) : (
          <div className="flex flex-col items-center gap-3 p-8 text-center">
            <ArrowUpCircle className="h-16 w-16 text-amber-400" />
            <div className="font-display text-2xl font-bold">{t("force_update_title")}</div>
            <div className="text-sm text-white/70">{t("force_update_body")}</div>
          </div>
        )}
      </button>
      <div className="mt-5 text-center text-xs text-white/60" data-testid="force-update-versions">
        {t("force_update_installed")} {status.installed} · {t("force_update_required")} {status.force_min}
      </div>
      <button
        type="button"
        data-testid="force-update-btn"
        onClick={() => openStoreUrl(status.platform, status.force_store_url)}
        className="mt-5 w-full max-w-sm h-14 rounded-2xl bg-amber-400 text-amber-950 font-bold text-lg flex items-center justify-center gap-2 active:bg-amber-500 transition-colors"
      >
        <ArrowUpCircle className="h-6 w-6" /> {t("force_update_cta")}
      </button>
    </div>
  );
};
